import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import { FormattedNumber } from 'react-intl'

import Icon from "../icon/icon.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";

const uuidv4 = require('uuid/v4')

class InlineEditNumber extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            text: this.props.value,
            value: this.props.value,
            endPoint: this.props.endPoint || '',
            field: this.props.field || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () {
            },
            isLoading: false,
            success: false,
            currency: this.props.currency || '',
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            text: nextProps.value,
            value: nextProps.value,
            endPoint: nextProps.endPoint || '',
            field: nextProps.field || '',
        })
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleFormChange(event) {
        this.setState({
            text: event.target.value
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
        })
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: parseFloat(this.state.text),
        }).then((r) => {
            const attr = r.attributes || {}
            this.setState({
                value: attr[this.state.field],
                editMode: false,
                isLoading: false,
                success: !r.error,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1500)
            })
        })
    }

    render() {

        let text = this.state.value
        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler}
                onMouseLeave={this.onMouseLeaveHandler}>
                <FormattedNumber
                    style={this.state.currency ? 'currency' : ''}
                    currency={this.state.currency}
                    value={text}
                />
                {!this.state.success ?
                    <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'}
                        className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />}
            </a>
            text = <span className="position-relative">
                {link}
                <div className={"dropdown-menu p-4 position-absolute " + (this.state.editMode ? 'show' : '')}
                    style={{ minWidth: '350px' }}>
                    <div className="w-100 m-0">
                        <input
                            value={this.state.text}
                            onChange={this.handleFormChange}
                            type="number"
                            className="form-control"
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={this.save}
                            isLoading={this.state.isLoading}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        } else {
            text = <FormattedNumber
                style={this.state.currency ? 'currency' : ''}
                currency={this.state.currency}
                value={text}
            />
        }

        return text
    }

}

export default InlineEditNumber





// WEBPACK FOOTER //
// ./src/common/inline-edit/number.component.jsx